import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const OptionsList = styled.ul<{
  visible: boolean;
}>`
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: ${SPACING._8};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  pointer-events: ${({ visible }) => (visible ? 'all' : 'none')};
  transition: 200ms;
`;
